<template>
  <!--
      作者 gmshop
      时间：2020-06-09
      描述：会员-等级管理-门店自提核销
  -->
  <el-dialog title="门店自提核销" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false"
             :close-on-press-escape="false" width="30%">
      <el-form size="small" ref="extract_form" :model="extract_form" label-width="100px">
        <el-form-item label="门店核销员" prop="clerk_id">
          <el-select v-model="extract_form.order.extract_clerk_id" placeholder="点击选择" v-if="dataModel.delivery_type.value == 20">
            <el-option :label="item.real_name" v-for="(item, index) in shopClerkList" :key="index" :value="item.clerk_id"></el-option>
          </el-select>
          <el-select v-model="extract_form.order.extract_clerk_id" placeholder="点击选择" v-if="dataModel.delivery_type.value == 60">
            <el-option :label="item.real_name" v-for="(item, index) in shopClerkList" :key="index" :value="item.is_store_clerk_id"></el-option>
          </el-select>
        </el-form-item>
       <el-form-item label="买家取货状态 ">
         <el-radio v-model="extract_form.order.extract_status" :label="1">已取货</el-radio>
       </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible">取 消</el-button>
          <el-button type="primary" @click="onExtract(dataModel.order_id)" :loading="loading">确认核销</el-button>
      </div>
  </el-dialog>
</template>

<script>
  import OrderApi from '@/api/order.js';
  export default {
    data() {
        return {
          shopClerkList: [],
          extract_form: {
            order: {
              extract_status: 1,
            }
          },
          /*是否显示*/
          dialogVisible: true,

      };
    },
    props: ['dataModel'],
    created() {
        this.getParams();

    },
    methods: {
      /*获取参数*/
      getParams() {
        let self = this;
        OrderApi.shopClerkList({
          delivery_type: self.dataModel.delivery_type.value
        }, true)
          .then(data => {
            self.loading = false
            self.shopClerkList = data.data.shopClerkList;
          })
          .catch(error => {
            self.loading = false;
          });
      },
    /*核销*/
    onExtract(e) {
      let self = this;
      let extract_form = self.extract_form;
      extract_form.order_id = e;
      OrderApi.extract({
            extract_form
          },
          true
        )
        .then(data => {
          self.loading = false;
          self.$message({
            message: '恭喜你，操作成功',
            type: 'success'
          });
          self.dialogFormVisible();
        })
        .catch(error => {
          self.loading = false;
        });
    },
    /*关闭弹窗*/
    dialogFormVisible() {
        this.$emit('closeDialog', {openDialog: false});
    }
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/order/order/dialog/Extract.vue